import React from 'react';
import { Content, Header, Page } from '@backstage/core-components';
import { CatalogTable, CatalogKindHeader } from '@backstage/plugin-catalog';
import {
  CatalogFilterLayout,
  EntityListProvider,
  EntityKindPicker,
  EntityTypePicker,
  UserListPicker,
  EntityTagPicker,
} from '@backstage/plugin-catalog-react';

export const CustomCatalogPage = () => {
  return (
    <Page themeId="home">
      <Header title="Application Catalog" subtitle="Discover and manage your applications" />
      <Content>
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker initialFilter="component" />
              <EntityTypePicker />
              <UserListPicker />
              <EntityTagPicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <CatalogKindHeader />
              <CatalogTable />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </Page>
  );
};
